import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip,
  Divider,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const TabBasicInfo = ({ patient }) => {
  const formatDate = (isoDate) => isoDate?.split("T")[0] || "N/A";

  const getStatusColor = (status) =>
    status === "ACTIVE" ? "success" : "error";

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        🧾 Basic Patient Information
      </Typography>

      <Grid container spacing={2}>
        {/* Nombre y estado */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <PersonIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }} />
            <strong>Full Name:</strong> {patient?.memberFullName || "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <VerifiedUserIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }} />
            <strong>Patient Status:</strong>{" "}
            <Chip
              label={patient?.status || "N/A"}
              color={getStatusColor(patient?.status)}
              size="small"
              sx={{ fontWeight: "bold" }}
            />
          </Typography>
        </Grid>

        {/* Fecha de nacimiento y edad */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <CalendarMonthIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }} />
            <strong>DOB:</strong> {formatDate(patient?.dateOfBirth)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            🧓 <strong>Age:</strong> {patient?.age || "N/A"}
          </Typography>
        </Grid>

        {/* Género y email */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            🚻 <strong>Gender:</strong> {patient?.gender || "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <EmailIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }} />
            <strong>Email:</strong> {patient?.memberEmail || "N/A"}
          </Typography>
        </Grid>

        {/* Teléfono */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            <PhoneIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 1 }} />
            <strong>Phone:</strong>{" "}
            {patient?.memberPhone || patient?.memberMobile || "N/A"}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        📅 Last Visit & Membership
      </Typography>

      <Grid container spacing={2}>
        {/* Última visita */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            🏥 <strong>Last Visit:</strong>{" "}
            {patient?.lastVisitDate ? formatDate(patient.lastVisitDate) : "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            🧭 <strong>Visit Location:</strong>{" "}
            {patient?.lastVisitLocation || "N/A"}
          </Typography>
        </Grid>

        {/* Membresía */}
        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            💳 <strong>Member Type:</strong> {patient?.memberType || "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            📆 <strong>Plan Start:</strong>{" "}
            {formatDate(patient?.membershipStart)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            ⏳ <strong>Plan End:</strong>{" "}
            {formatDate(patient?.membershipEnd)}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="body1">
            👨‍⚕️ <strong>PCP:</strong> {patient?.pcpName || "Unassigned"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TabBasicInfo;
